module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Motherless")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  })]), _c('a', {
    attrs: {
      "id": "page1"
    }
  }), _c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#sam_33",
      "id": "sam_1"
    }
  }, [_vm._v("1997")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('i', [_vm._v("Locals have been saying for years that this stretch of sand ")]), _vm._v("called Monastery Beach is anything but a sanctuary. It’s the Venus flytrap of the California coast. The ocean cuts into the land here, and the sudden postcard view that pops up in front of the highway has caused many a driver to drift across the center line. Travelers make the spontaneous decision to stop for a stretch and a family photo: just look at that gorgeous blue backdrop, that sultry smile of coastline, that easy walk from the car to the packed sand.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For heaven’s sake, it’s called Monastery Beach. Who could know at a glance how deadly it is?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I hear the diving just offshore is amazing, though that adventure is for the experienced only, those who know what they’re diving into. Those people have seen the uncommonly steep underwater drop-off here, hidden by the surface. They understand the powerful undertow, the wintertime dangers. They "), _c('i', [_vm._v("expect")]), _vm._v(" the sleeper waves to tower out of nowhere and smash them onto the sand, then grab them by the ankles and drag them into the instant depths. They know about the tragic drownings and the doubly tragic rescue attempts. They’ve seen the death toll climb year after year.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But the happily ignorant vacationers? They turn their backs "), _c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_vm._v("on the monster to smile for the camera. Once a single wave swallowed a family of four. In spite of posted signs that diagram the danger, too many don’t heed the warnings.")])]), _c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("I park on the shoulder of Highway 1, under the low branches of an old salt-whipped tree. People park here all the time—in summer vehicles line the road door-to-door and bumper to bumper—but it’s nearly winter, and no one’s here yet, if anyone will come at all this morning. The sun isn’t shining even though it has recently risen. The winds are spitting sleet across my windshield, and clouds press down heavily. The beastly surf rattles its cage, daring me to come closer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I take what’s mine and leave what I want others to find. I close the door and leave the empty car unlocked. Why frustrate the search?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The old monastery sits right there on the other side of the highway. I stand on this skinny strip of asphalt, the only thing separating life from death. I could turn in either direction. Strange hope swells in me, then settles back into the sea. Yesterday I might have looked for refuge in that place where they believe God welcomes sinners. But not now.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Like the unwitting visitors who make the mistake of taking their eyes off the water, I put the monastery at my back and face my fate. Unlike them, I am fully informed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("See, the locals call this place Mortuary Beach, and I am here to save my children from my sins.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecba1744","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter4.vue
// module id = 81
// module chunks = 0